const months = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

const oldMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default months;
